import { render, staticRenderFns } from "./JiraVelocity.vue?vue&type=template&id=da459ce2&scoped=true"
import script from "./JiraVelocity.vue?vue&type=script&lang=js"
export * from "./JiraVelocity.vue?vue&type=script&lang=js"
import style0 from "./JiraVelocity.vue?vue&type=style&index=0&id=da459ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da459ce2",
  null
  
)

export default component.exports